<template>
  <div class="mobile-page">
    <div class="sub-nav">
      <button class="back-btn" @click="back"><el-icon :size="18"><ArrowLeft /></el-icon></button>
      <span class="nav-title">值班领导</span>
      <span class="nav-right"><button class="refresh-btn" @click="load"><el-icon :size="16"><Refresh /></el-icon></button></span>
    </div>

    <div class="mobile-body">
      <div class="search-line">
        <el-input v-model="kw" placeholder="搜索日期 / 姓名 / 职务" clearable size="default">
          <template #prefix><el-icon><Search /></el-icon></template>
        </el-input>
      </div>

      <div v-if="loading" class="center-box">
        <el-icon class="is-loading" :size="28"><Loading /></el-icon>
        <p class="sub-text">加载中…</p>
      </div>
      <div v-else-if="error" class="white-card center-box">
        <el-icon :size="36" color="#c5221f"><WarningFilled /></el-icon>
        <p class="sub-text">{{ error }}</p>
        <el-button size="small" type="primary" plain style="margin-top:10px" @click="load">重试</el-button>
      </div>
      <div v-else-if="list.length === 0" class="white-card center-box">
        <el-icon :size="40" color="#c0c4cc"><UserFilled /></el-icon>
        <p class="sub-text">{{ kw ? '没有匹配的值班领导' : '暂无值班领导（请先发布配置）' }}</p>
      </div>

      <template v-else>
        <div class="leader-card" v-for="d in list" :key="d.id">
          <div class="lc-left">
            <div class="lc-avatar"><el-icon :size="20"><User /></el-icon></div>
          </div>
          <div class="lc-main">
            <div class="lc-name-row">
              <span class="lc-name">{{ d.name }}</span>
              <span class="pill pill-purple">{{ d.title || '值班领导' }}</span>
            </div>
            <div class="lc-sub">
              <el-icon :size="13"><Calendar /></el-icon>
              <span>{{ formatDate(d.plan_date) }}</span>
              <span v-if="d.plan_date === today" class="pill pill-green today-pill">今天</span>
            </div>
            <div class="lc-sub" v-if="d.phone">
              <el-icon :size="13"><Phone /></el-icon>
              <a class="lc-phone" :href="'tel:' + d.phone">{{ d.phone }}</a>
            </div>
            <div class="lc-sub muted" v-if="d.remark">备注：{{ d.remark }}</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { fetchSchedule } from '../api'
import dayjs from 'dayjs'

const router = useRouter()
function back() { router.back() }

const loading = ref(true)
const error = ref('')
const kw = ref('')
const leaders = ref([])
const today = dayjs().format('YYYY-MM-DD')

const list = computed(() => {
  let arr = [...leaders.value]
  arr.sort((a, b) => String(b.plan_date || '').localeCompare(String(a.plan_date || '')))
  const k = kw.value.trim().toLowerCase()
  if (!k) return arr
  return arr.filter(d => {
    const hay = [d.plan_date, d.name, d.title, d.phone, d.remark].join(' ').toLowerCase()
    return hay.includes(k)
  })
})

function formatDate(date) {
  if (!date) return '未排期'
  const d = dayjs(date)
  return `${d.format('YYYY年MM月DD日')} 周${'日一二三四五六'.charAt(d.day())}`
}

async function load() {
  loading.value = true
  error.value = ''
  try {
    const r = await fetchSchedule()
    leaders.value = r.dutyLeaders || []
  } catch (e) {
    error.value = e.message || '加载失败'
  } finally {
    loading.value = false
  }
}

onMounted(load)
</script>

<style scoped>
.search-line { display: flex; gap: 8px; margin-bottom: 10px; }

.leader-card {
  display: flex; gap: 12px; background: #fff; border-radius: 14px; padding: 14px;
  box-shadow: 0 3px 12px rgba(31,45,61,.06); margin-bottom: 10px;
}
.lc-avatar {
  width: 46px; height: 46px; border-radius: 50%; background: linear-gradient(135deg, #7a5af5, #a06df0);
  color: #fff; display: flex; align-items: center; justify-content: center;
}
.lc-main { flex: 1; min-width: 0; }
.lc-name-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.lc-name { font-size: 16px; font-weight: 700; color: #202124; }
.lc-sub {
  display: flex; align-items: center; gap: 6px; font-size: 12.5px; color: #5f6368;
  margin-top: 5px; flex-wrap: wrap;
}
.today-pill { font-size: 10.5px; padding: 1px 8px; }
.lc-phone { color: #1a73e8; text-decoration: none; }
.muted { color: #9aa0a6; }
</style>
